'use client';

import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';
import { attemptChunkReload, isChunkLoadError } from '@/lib/chunkError';
import './error.css';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    if (!error) return;

    // reset() re-renders the same tree and re-requests the missing chunk.
    // Hard-reload instead to fetch fresh HTML with current chunks.
    if (isChunkLoadError(error)) {
      attemptChunkReload(error);
      return;
    }

    datadogRum.addError(error, {
      message: 'Fatal error triggered root client error boundary',
    });
  }, [error]);
  return (
    <div id="nw-50x">
      <div id="nw-heading-wrap">
        <h1>Sorry, looks like something slipped up.</h1>
      </div>
      <div className="nw-button-wrap">
        <a className="nw-button" onClick={reset}>
          Let&apos;s try that again!
        </a>
      </div>
    </div>
  );
}
